// @flow
import type { CurrentUser } from 'api/currentUser';

export const isStaff = (user: CurrentUser) =>
  user && user.permissions && user.permissions.includes('staff');

export const isLoggedIn = (user?: CurrentUser) => user && user.id;

export const isNonAdmin = (user: CurrentUser) =>
  Boolean(
    user &&
      user.id &&
      user.permissions &&
      !['staff', 'orgAdmin'].some(permission =>
        user.permissions.includes(permission)
      )
  );
